module.exports = __webpack_public_path__ + "img/file_video.abcf1f90.svg";